import { DsFormTemplate } from './ds-form-template';
import { DsFormTemplateCategoryInterface } from '../interfaces/foms-models/ds-form-template-category.interface';

export class DsFormTemplateCategory {
  /**
   *
   */
  id?: number;

  /**
   *
   */
  name: string;

  /**
   *
   */
  children?: DsFormTemplate[];

  /**
   * Creates an instance of DsFormTemplateCategory.
   *
   * @param json the json data
   */
  constructor(json: DsFormTemplateCategoryInterface) {
    if (json.id) {
      this.id = json.id;
    }
    this.name = json.name;
  }
}
